import { PodcastStatusEnum } from '../../../../types/enums'
import type { Podcast } from '../../../../types/podcast'

export const useEditorState = (
  podcast?: Podcast,
  scriptJobStatus?: string,
  currentLinesCount?: number
) => {
  // Show skeleton when podcast is processing or script is explicitly running and has no lines yet
  const isProcessing = podcast?.status === PodcastStatusEnum.Processing
  const hasNoLines = currentLinesCount === 0
  const isScriptRunning = scriptJobStatus === 'running'
  const shouldShowSkeleton = podcast?.isGenerating || (isProcessing || isScriptRunning) && hasNoLines

  const shouldShowError = scriptJobStatus === 'failed' && hasNoLines
  const shouldShowEmptyDraft = (hasNoLines && !shouldShowSkeleton && !shouldShowError)

  return {
    shouldShowSkeleton,
    shouldShowError,
    shouldShowEmptyDraft,
    hasContent: !shouldShowSkeleton && !shouldShowError && !shouldShowEmptyDraft,
  }
}
